<template>
  <Layout>
    <confirm-modal
      v-bind:bodyText="textConfirmDeleteModal"
      v-bind:show="confirmDeleteModal"
      @confirm="onDelete()"
      @hidden="
        confirmDeleteModal = false;
        textConfirmDeleteModal = '';
        id = 0;
      "
    >
    </confirm-modal>
    <PageHeader :title="title" :items="itemsPageHeader" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-sm-8"></div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-row form-group">
                  <label class="col-md-4 col-form-label">Employee ID</label>
                  <div class="col-md-8">
                    <input
                      v-model="filter.employee_id"
                      type="text"
                      placeholder="Employee ID"
                      class="form-control"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-row form-group">
                  <label class="col-md-4 col-form-label">Name</label>
                  <div class="col-md-8">
                    <input
                      v-model="filter.name"
                      type="text"
                      placeholder="Name"
                      class="form-control"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-row form-group">
                  <label class="col-md-4 col-form-label">E-Mail</label>
                  <div class="col-md-8">
                    <input
                      v-model="filter.email"
                      type="text"
                      placeholder="E-Mail"
                      class="form-control"
                    />
                    <!-- onkeypress="return event.charCode >= 48 && event.charCode <= 57" -->
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-row form-group">
                  <label class="col-md-4 col-form-label">Open ID</label>
                  <div class="col-md-8">
                    <input
                      v-model="filter.open_id"
                      type="text"
                      placeholder="Open ID"
                      class="form-control"
                      onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-row form-group">
                  <label class="col-md-4 col-form-label">Application</label>
                  <div class="col-md-8">
                    <!-- {{ GET_FILTER_APPLICATION }} -->
                    <multiselect
                      v-model="filter.appSelected"
                      label="display_name"
                      :loading="isLoadingApplication"
                      placeholder="Please select group"
                      :options="applications"
                    >
                      <template slot="singleLabel" slot-scope="{ option }">
                        <strong>{{ option.display_name }}</strong>
                      </template>
                    </multiselect>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-row form-group">
                  <label class="col-md-4 col-form-label">Status</label>
                  <div class="col-form-label row" style="margin-left: 0px">
                    <b-form-checkbox
                      @change="onSelectAll($event)"
                      class="custom-checkbox custom-checkbox-outline custom-checkbox-info mb-3"
                      style="margin-right: 10px"
                      name="allStatus"
                      id="allStatus"
                      v-model="isSelectAllStatus"
                      >All</b-form-checkbox
                    >
                    <b-form-checkbox
                      v-model="filter.status"
                      value="Active"
                      class="custom-checkbox custom-checkbox-outline custom-checkbox-success mb-3"
                      style="margin-right: 10px"
                      name="active"
                      id="active"
                      >Active</b-form-checkbox
                    >
                    <b-form-checkbox
                      v-model="filter.status"
                      value="Inactive"
                      class="custom-checkbox custom-checkbox-outline custom-checkbox-danger mb-3"
                      style="margin-right: 10px"
                      name="inactive"
                      id="inactive"
                      >Inactive</b-form-checkbox
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12 text-sm-right">
                <div class="button-items">
                  <button
                    type="button"
                    class="btn btn-primary waves-effect"
                    @click="onFilter()"
                  >
                    <i class="bx bx-search font-size-16 align-middle mr-2"></i>
                    Search
                  </button>
                  <button
                    type="button"
                    class="btn btn-light waves-effect"
                    @click="onClear()"
                  >
                    <i class="bx bx-reset font-size-16 align-middle mr-2"></i>
                    Clear
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card" v-if="showDataTable">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    จำนวน&nbsp;
                    <b-form-select
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                      @change="onFilter()"
                    ></b-form-select
                    >&nbsp;รายการ
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-right"
                >
                  <label class="d-inline-flex align-items-center">
                    <b-form-input
                      v-model="search"
                      type="search"
                      :placeholder="`Search in page ${pageNo} `"
                      class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="row" v-if="hasData">
              <div
                class="col-lg-12 pagination pagination-rounded justify-content-end mb-2"
              >
                <div style="position: relative; top: 7px">
                  รายการที่ {{ firstRowOnPage }} -
                  {{ lastRowOnPage }} จากทั้งหมด {{ totalRecords }} รายการ
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="table-responsive">
                  <b-table
                    class="table table-centered table-nowrap"
                    ref="usertable"
                    :empty-text="'ไม่พบข้อมูล'"
                    :show-empty="!hasData"
                    :bordered="true"
                    :filter="search"
                    :items="items"
                    align="center"
                    v-bind:fields="fields"
                    @filtered="onFiltered"
                    :perPage="perPage"
                  >
                    <template v-slot:cell(index)="data">
                      <div class="text-right">
                        {{ firstRowOnPage + data.index }}
                      </div>
                    </template>
                    <template v-slot:cell(email)="data">
                      <div v-if="data.item.info">
                        <span>
                          {{ data.item.info.email }}
                        </span>
                      </div>
                    </template>
                    <template v-slot:cell(info)="data">
                      <label
                        class="col-form-label col-sm-5"
                        v-if="data.value.first_name && data.value.first_name.th"
                      >
                        <span class="badge-lang">TH</span
                        >{{ data.value.first_name.th }}
                        {{ data.value.last_name.th }}
                      </label>
                      <br />
                      <label
                        class="col-form-label col-sm-5"
                        v-if="data.value.first_name && data.value.first_name.en"
                      >
                        <span class="badge-lang">EN</span
                        >{{ data.value.first_name.en }}
                        {{ data.value.last_name.en }}
                      </label>
                    </template>

                    <template v-slot:cell(crc_id)="data">
                      <div v-if="data.item.reference_id">
                        <span>
                          {{ data.item.reference_id.crc_id }}
                        </span>
                      </div>
                    </template>
                    <template v-slot:cell(applications)="data">
                      <div
                        v-for="(itemApp, indexApp) in data.value"
                        v-bind:key="indexApp"
                      >
                        <span
                          class="badge badge-pill badge-soft-success font-size-11"
                          ><b>{{ itemApp.display_name }}</b
                          >:
                          {{
                            itemApp.groups
                              .map((entry) => entry.display_name)
                              .join(", ")
                          }}
                        </span>
                        <br />
                        <!-- <div
                          v-for="(itemGroup, indexGroup) in itemApp.groups"
                          v-bind:key="indexGroup"
                        >
                          <span
                            class="badge badge-pill badge-soft-success font-size-11"
                          >
                            {{ itemGroup.display_name }}
                          </span>
                          <br />
                        </div> -->
                      </div>
                    </template>
                    <template v-slot:cell(status)="data">
                      <span
                        class="label"
                        :class="'label-' + data.value.toLowerCase()"
                        v-html="data.value"
                      ></span>
                    </template>
                    <template v-slot:cell(action)="data">
                      <div class="button-items">
                        <a
                          @click="
                            $router.push({
                              name: 'user_detail',
                              params: { id: data.item.id },
                            })
                          "
                          class="btn btn-warning"
                          ><i class="bx bx-edit-alt label-icon"></i
                        ></a>
                        <button
                          v-if="checkReSyncAD(data.item)"
                          @click="onSyncUpdateAd(data.item.id)"
                          type="button"
                          class="btn btn-success waves-effect waves-light"
                          title="Re-sync user information with AD"
                        >
                          <i class="mdi mdi-sync label-icon"></i>AD
                        </button>
                      </div>
                    </template>
                  </b-table>
                </div>
              </div>
            </div>
            <div class="row" v-if="hasData">
              <div class="col-lg-4">
                <div style="position: relative; top: 7px">
                  รายการที่ {{ firstRowOnPage }} -
                  {{ lastRowOnPage }} จากทั้งหมด {{ totalRecords }} รายการ
                </div>
              </div>
              <div class="col-lg-8">
                <b-pagination
                  :total-rows="totalRecords"
                  :per-page="perPage"
                  v-model="pageNo"
                  @change="onClickPagination($event)"
                  class="pagination pagination-rounded justify-content-end mb-2"
                />
              </div>
            </div>
          </div>
        </div>
        <loading :active.sync="isLoading" ></loading>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { FormatQty } from "@/helpers/utils/format-qty.js";

import appConfig from "@/app.config";
import { eventBus } from "@/main.js";
import ConfirmModalComponnent from "@/components/share/modal-confirm.vue";
import { userComputed, userMethods } from "@/state/helpers";
import userService from "@/helpers/service/user-provider";
import applicationService from "@/helpers/service/application-provider";
import { applicationComputed, applicationMethods } from "@/state/helpers";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  name: "user",
  page: {
    title: "User",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader,Loading, "confirm-modal": ConfirmModalComponnent },
  data() {
    return {
      isLoading: false,
      isLoadingApplication: false,
      search: null,
      title: "User",
      itemsPageHeader: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "User",
          active: true,
        },
      ],
      fields: [
        {
          key: "index",
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0);
          },
          label: "ลำดับ",
          thStyle: "width:80px",
          sortable: false,
        },
        {
          key: "reference_id.crc_id",
          label: "Employee Id(CRC Id)",
          sortable: true,
        },
        {
          key: "info.email",
          label: "Email",
          sortable: true,
        },
        {
          key: "info",
          label: "Name",
          sortable: true,
        },
        {
          key: "applications",
          label: "Group",
          sortable: true,
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
        },
        {
          key: "action",
          label: "Action",
          thStyle: "width:80px",
        },
      ],
      listModel: {
        type: Object,
        default: () => {
          return {
            firstRowOnPage: 0,
            items: [],
            lastRowOnPage: 0,
            pageNo: 0,
            totalPages: 0,
            totalRecords: 0,
            pageSize: 0,
            prevPage: 0,
            nextPage: 0,
          };
        },
      },
      items: [],
      pageNo: 0,
      totalPages: 0,
      firstRowOnPage: 0,
      lastRowOnPage: 0,
      totalRecords: 0,
      perPage: 50,
      filter: {
        open_id: "",
        employee_id: "",
        name: "",
        email: "",
        groups: [],
        status: [],
        appSelected: null,
      },
      isSelectAllStatus: true,
      selectAllStatus: ["Active", "Inactive"],
      isSelectAllGroup: true,
      selectAllGroup: ["SuperUser", "Admin"],
      pageOptions: [5, 10, 25, 50, 100],
      confirmDeleteModal: false,
      textConfirmDeleteModal: "",
      id: 0,
      showDataTable: false,
      applications: [],
    };
  },
  computed: {
    ...applicationComputed,
    ...userComputed,
    isApplications() {
      return (
        this.applications !== undefined &&
        this.applications !== null &&
        this.applications.length > 0
      );
    },
    hasData() {
      return this.$validate.anyArrayObjectValid(this.items);
    },
  },
  mounted() {
    // this.getApplicationsAsync();
    // this.filter = Object.assign({}, this.GET_FILTER_USER);
    // if (this.filter.isFilter) {
    //   this.onFilter();
    // }
  },
  watch: {
    isSelectAllStatus: {
      handler(newVal) {
        if (newVal) {
          this.filter.status = ["Active", "Inactive"];
        }
      },
      immediate: true,
    },
    "filter.status": {
      handler() {
        this.isSelectAllStatus =
          this.filter.status.length === this.selectAllStatus.length
            ? true
            : false;
      },
      deep: true,
    },
    "filter.groups": {
      handler() {
        this.isSelectAllGroup =
          this.filter.groups.length === this.selectAllGroup.length
            ? true
            : false;
      },
      deep: true,
    },
    GET_FILTER_USER(val, oldVal) {
      this.filter = Object.assign({}, val);
    },
    listModel: function (value) {
      this.totalPages = value.totalPages;
      this.firstRowOnPage = (value.pageNo - 1) * value.pageSize + 1;
      this.lastRowOnPage =
        value.pageSize <= 0
          ? value.totalRecords
          : Math.min(value.pageNo * value.pageSize, value.totalRecords);
      this.totalRecords = value.totalRecords;
      // this.$refs.usertable.localSortBy = "";
      this.items = value.items;
      // this.perPage = value.pageSize;
      this.pageNo = value.pageNo;
    },
  },
  methods: {
    ...userMethods,
    onSelectAll(event) {
      this.filter.status = event ? this.selectAllStatus : [];
    },
    onSelectAllGroup(event) {
      this.filter.groups = event ? this.selectAllGroup : [];
    },
    async onFiltered(filteredItems) {
      this.totalPages = filteredItems.length;
    },
    async onClickPagination(pageNo) {
      this.search = "";
      let params = new URLSearchParams();
      params.append("pageSize", this.perPage);
      params.append("page", pageNo);
      params.append("open_id", this.filter.open_id.trim() || "");
      params.append("employee_id", this.filter.employee_id.trim() || "");
      params.append("name", this.filter.name.trim() || "");
      params.append("email", this.filter.email.trim() || "");
      if (!this.isSelectAllStatus) {
        this.filter.status.forEach((element) => {
          params.append("status", element);
        });
      }
      this.filter.groups.forEach((element) => {
        params.append("groups", element);
      });
      let result = await userService.getUsersAsync(params);

      if (result.status === 200) {
        this.listModel = result.data;
      } else if (result.response.status === 404) {
        console.log("error", result.response.data.message);
      } else {
        eventBus.$emit("error-modal", result.response.data.message);
      }
    },
    async onFilter() {
      this.isLoading = true;
      this.showDataTable = false;
      let params = new URLSearchParams();
      params.append("pageSize", this.perPage);
      //  console.log(this.perPage);
      params.append("open_id", this.filter.open_id.trim() || "");
      params.append("employee_id", this.filter.employee_id.trim() || "");
      params.append("name", this.filter.name.trim() || "");
      params.append("email", this.filter.email.trim() || "");
      if (this.filter.appSelected)
        params.append("application_id", this.filter.appSelected.id || "");

      if (!this.isSelectAllStatus) {
        this.filter.status.forEach((element) => {
          params.append("status", element);
        });
      }
      this.filter.groups.forEach((element) => {
        params.append("groups", element);
      });

      let result = await userService.getUsersAsync(params);
      if (result.status === 200) {
        this.isLoading = false;

        this.listModel = result.data;
        this.showDataTable = true;
      } else if (result.response.status === 404) {
        console.log("error", result.response.data.message);
      } else {
        eventBus.$emit("error-modal", result.response.data.message);
      }
      this.ADD_FILTER_USER(this.filter);
    },
    onClear() {
      this.filter = {
        open_id: "",
        employee_id: "",
        name: "",
        email: "",
        groups: [],
        status: [],
      };
    },
    onConfirmDelete(id, name) {
      this.id = id;
      this.textConfirmDeleteModal =
        "คุณต้องการลบUser <b>" + name + "</b> หรือไม่ ?";
      this.confirmDeleteModal = true;
    },
    async onDelete() {
      let result = await userService.deleteUserMasterByIdAsync(this.id);
      if (result.status === 200) {
        this.textConfirmDeleteModal = "";
        this.confirmDeleteModal = false;
        this.id = 0;
        this.$utils.notification("success", "ลบข้อมูลสำเร็จ", 1500);
        this.onFilter();
      } else {
        this.textConfirmDeleteModal = "";
        this.confirmDeleteModal = false;
        this.id = 0;
        eventBus.$emit("error-modal", result.response.data.message);
      }
    },
    async onSyncUpdateAd(userId) {
      userService
        .updateSyncAdUserAsync(userId)
        .then((result) => {
          if (result.status === 204) {
            this.textConfirmDeleteModal = "";
            this.confirmDeleteModal = false;
            this.id = 0;
            eventBus.$emit("info-modal", "อัพเดทข้อมูล AD สำเร็จ");
            this.onFilter();
          } else {
            this.textConfirmDeleteModal = "";
            this.confirmDeleteModal = false;
            this.id = 0;
            eventBus.$emit("error-modal", "อัพเดทข้อมูลไม่สำเร็จ");
          }
        })
        .catch((err) => {
          this.textConfirmDeleteModal = "";
          this.confirmDeleteModal = false;
          this.id = 0;
          eventBus.$emit("error-modal", "อัพเดทข้อมูลไม่สำเร็จ");
        });
    },
    async getApplicationsAsync() {
      this.showDataTable = true;
      let params = new URLSearchParams();
      params.append("pageSize", 50);
      params.append("status", "Active");

      let result = await applicationService.getApplicationsAsync(params);
      if (result.status === 200) {
        // console.log(result.data.items);

        this.applications = result.data.items;
        // this.applications = [];
        // var tmp = [];
        // result.data.items.forEach((element, index) => {
        //   //   if (index !== 0 && index % 3 == 0) {
        //   //     this.applications.push({ items: tmp });
        //   tmp = [];
        //   tmp.push(element);
        //   //   } else {
        //   //     tmp.push(element);
        //   //     if (index + 1 === result.data.items.length) {
        //   this.applications.push({ items: tmp });
        //   //     }
        //   //   }
        // });
        this.isLoading = false;
      } else if (result.response.status === 404) {
        console.log("error", result.response.data.message);
      } else {
        eventBus.$emit("error-modal", result.response.data.message);
      }
      this.isLoadingApplication = false;
    },
    checkReSyncAD(item) {
      return (
        item !== null &&
        item.id !== null &&
        this.$validate.isValid(item.info.email) &&
        (item.info.email.includes("@ofm.co.th") ||
          item.info.email.includes("@officemate.co.th") ||
          item.info.email.includes("@b2s.co.th") ||
          item.info.email.includes("@central.co.th"))
      );
    },
  },
};
</script>
<style>
.spinner-border {
  width: 3rem;
  height: 3rem;
}
</style>
